import React from 'react';

const LoadingFallback: React.FC = () => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-4">
      <div className="w-16 h-16 border-t-4 border-b-4 border-avn-purple-600 rounded-full animate-spin mb-4"></div>
      <h2 className="text-xl font-semibold text-gray-700">Loading AVN Network...</h2>
      <p className="text-gray-500 mt-2 text-center max-w-md">
        We're preparing your ethical agricultural experience. Please wait a moment.
      </p>
    </div>
  );
};

export default LoadingFallback;